import {Reservation} from "../../../../../server/src/base/entities/leasing/calendar/Reservation";
import {IReservationsFilter} from "../../infrastructure/leasing/IReservationsFilter";
import {ReservationFilter} from "../../infrastructure/leasing/ReservationFilter";
import {CalendarSlot} from "../../entities/CalendarSlot";
import {IVanCalendar} from "./IVanCalendar";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";
import {Slot} from "../../../../../server/src/base/entities/leasing/calendar/Slot";
import {CalendarDaySlot} from "../../entities/CalendarDaySlot";

export class VanCalendar extends IVanCalendar{

    private van:Van;
    private reservationsOfCurrentMonth:Array<Reservation>;
    private currentMonth:Date;
    private reservationFilter:IReservationsFilter;
    private slots:Array<CalendarSlot>;

    constructor(van:Van, startingDate:Date = new Date()) {
        super();
        this.van = van;
        this.slots = [];
        this.ComputeNowDate(startingDate);
        this.Refresh();
    }

    public Update(van:Van){
        this.van = van;
        this.slots = [];
        this.Refresh();
    }

    public NextMonth() {
        this.currentMonth.setMonth(this.currentMonth.getMonth() + 1);
        this.Refresh();
    }

    public PreviousMonth() {
        this.currentMonth.setMonth(this.currentMonth.getMonth() - 1);
        this.Refresh();
    }

    public Slots(): Array<CalendarSlot> {
        return this.slots;
    }

    public CurrentMonth(): Date {
        return this.currentMonth;
    }

    public FirstDayOfTheMonth(): number {
        return this.FirstTimeOfTheMonth().getDay();
    }

    public LastDayOfTheMonth(): number {
        return this.LastTimeOfTheMonth().getDay();
    }

    CalendarSlot(slot: Slot): CalendarDaySlot {
        let calendarSlot = this.slots[slot.Day() - 1];
        console.log(slot.Value() + ' ' + calendarSlot.ToString());
        if(slot.IsMorning()){
            return calendarSlot.DaySlots()[0];
        }
        else{
            return calendarSlot.DaySlots()[1];
        }
    }

    private Refresh(){
        this.ComputeReservationsOfCurrentMonth();
        this.ComputeSlots();
    }

    private ComputeReservationsOfCurrentMonth(){
        this.reservationsOfCurrentMonth = [];
        this.reservationFilter = new ReservationFilter(this.FirstTimeOfTheMonth(), this.LastTimeOfTheMonth());
        for(let reservation of this.van.calendar.reservations){
            if(this.reservationFilter.IsValid(reservation)){
                this.reservationsOfCurrentMonth.push(reservation);
            }
        }
    }

    private ComputeSlots(){
        let newSlots = this.CreateSlotsOfCurrentMonth();
        this.CheckSlotsAvailable(newSlots);
        this.slots = newSlots;
    }

    private CreateSlotsOfCurrentMonth():Array<CalendarSlot>{
        let slots:Array<CalendarSlot> = [];
        let nbDaysInMonth:number = this.DaysInMonth();
        for(let i = 1 ; i <= nbDaysInMonth ; ++i){
            slots.push(new CalendarSlot(i));
        }
        return slots;
    }

    private CheckSlotsAvailable(slots:Array<CalendarSlot>){
        for(let slot of slots){
            if(!this.CheckDateAvailable(new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), slot.Day(), 1))){
                slot.DaySlots()[0].Taken();
            }
            if(!this.CheckDateAvailable(new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), slot.Day(), 13))){
                slot.DaySlots()[1].Taken();
            }
        }
    }

    private CheckDateAvailable(date:Date):boolean{
        for(let reservation of this.reservationsOfCurrentMonth){
            if(reservation.slot.Date().getTime() == date.getTime()){
                return false;
            }
        }
        return true;
    }

    private DaysInMonth ():number {
        return new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDate();
    }

    private ComputeNowDate(startingDate:Date){
        this.currentMonth = startingDate;
        this.currentMonth.setDate(1);
        this.currentMonth.setHours(1);
        this.currentMonth.setMinutes(0);
        this.currentMonth.setSeconds(0);
        this.currentMonth.setMilliseconds(0);
    }

    private FirstTimeOfTheMonth():Date{
        return new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1, 1);
    }

    private LastTimeOfTheMonth():Date{
        return new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0, 13);
    }

    public ToString():string{
        let value = "";
        for(let slot of this.slots){
            value += "Slot { " + slot.Day() + ", AM: " + slot.DaySlots()[0].Available() + ", PM: " + slot.DaySlots()[1].Available() + "},\n"
        }
        return value;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/VanCalendar.ts